import type { TextPropSize, TextPropView } from '@consta/uikit/Text'

export const textProps: { size: TextPropSize; view: TextPropView } = {
  size: 'xs',
  view: 'secondary',
}
